import React from "react";
import DatePicker from './DatePicker'
import FixButton from './Button'
import Cookies from 'universal-cookie';
import moment from 'moment';

export default class SelectPdfDatesWidget extends React.Component {

    constructor (props){
        super(props);

        this.daDateRef = React.createRef();
        this.aDateRef = React.createRef();

    }

    async componentDidMount(){
    
        this.setState({
            visible: this.props.show,
        });

    }

    render (){

        if (!this.state) return <div />;
        let st = Object.assign({display: this.state.visible ? 'block' : 'none'}, mainClass);

        return ( 
        <div key={Math.random()} style={st} >
            <div style={closeIcon} onClick={() => {
                this.setState({visible: false});
                this.props.onCancel();
            }}>X</div>
            <div style={{marginTop: '10px'}}>
                <div className="windowTitle">Seleziona le date</div>


                    <DatePicker ref={this.daDateRef} name="Da:" />
                    <DatePicker ref={this.aDateRef} name="A:"/>

                    <FixButton title={'OK'} callback={this.okClicked.bind(this)} />
            </div>
        </div>
        )
    }

    checkInvestor(investors, id){
        investors.map(v => {
            if (v.id == id) return true;
        });
        return false;
    }

    async okClicked(){

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const currentEventId = cookies.get('currentEventId', { path: '/' });

        const daDate = this.daDateRef.current.getDate();
        const aDate = this.aDateRef.current.getDate();

        let da = moment(daDate).format('yyyy-MM-DD');
        let a = moment(aDate).format('yyyy-MM-DD');

        if (da == "Invalid date") da = "";
        if (a == "Invalid date") a = "";

        this.props.onOkClicked(da, a);
    }
}


const menu = {
    position: 'relative',
    top: '10px',
    display: 'flex',
};

const menuVoice = {
    width: '50%',
    textAlign: 'center',
    border: '1px solid black',
    cursor: 'pointer'
}

const title = {
    top: '10xp',
    width: '100%',
    height: '40px',
    lineHeight: '40px',
    textAlign: 'center',
};

const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 0, 
    top: 0, 
    padding: 10
}

const mainClass = {
    position: 'fixed',
    left: '35%',
    top: '10%',
    background: '#ffffff',
    border: '1px solid black',
    padding: '20px',
    zIndex: 999
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}


const inputTextDisabled = {
    background: '#eeeeee',
    width: '300px',
    padding: '10px'
}